'use client'

import useIsMobileViewport from '@/lib/hooks/use-is-mobile-viewport'
import { useAppStore } from '@/lib/store/store'

export default function useAudioAssetsLayout(isAudio: boolean) {
  const audioAssetsLayoutPreference = useAppStore((state) => state.audioAssetsLayoutPreference)
  const setAudioAssetsLayoutPreference = useAppStore((state) => state.setAudioAssetsLayoutPreference)
  const isMobileViewport = useIsMobileViewport()

  return {
    isMobileViewport,
    audioAssetsLayoutPreference,
    resolvedAudioGridLayout: isAudio && (isMobileViewport || audioAssetsLayoutPreference === 'grid'),
    setAudioAssetsLayoutPreference,
  }
}
